module.exports = __webpack_public_path__ + "static/assets/b6b18f1524eedba8ac881ab30c0ca546.png";